/* eslint-disable no-undef */
/* eslint-disable camelcase */
import React from 'react';
import ReactDOM from 'react-dom';

import { isCompatible, placeholder } from './_placeholder';
import '../translations/i18n';

require('../styles/main.scss');

export default (App) => {
  const rootNode = document.getElementById('app');
  if (isCompatible()) {
    ReactDOM.render(<App />, rootNode);
  } else {
    rootNode.innerHTML = placeholder();
  }
};
